/**
 * Pflichtfeld-Markierung an genau einer Stelle definiert.
 *
 * Die Farbe #C92A2A ist Mantines `red.9` -- dieselbe Linie, die `validatedFields`
 * bereits fuer Feldfehler nutzt (ERROR_LINE). Sie faerbt zwei Dinge, die immer
 * uebereinstimmen muessen:
 *  - das Sternchen, das Mantine hinter das Label eines Feldes mit `withAsterisk`
 *    setzt (ueber `InputWrapper.styles.required` im Theme)
 *  - das erklaerende Sternchen im Fliesstext („Pflichtfelder sind mit * markiert")
 */
export const REQUIRED_MARK_COLOR = 'var(--mantine-color-red-9)';

/** Das Sternchen fuer Fliesstext -- optisch identisch zu dem an den Feldlabels. */
export function RequiredMark() {
  return <span style={{ color: REQUIRED_MARK_COLOR }}>*</span>;
}
